import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { getGwsDomainValue } from '../../../utils/mapGwsPasswordFormValues'

const TAB_KEYS = {
  ACCOUNT_DETAILS: 'account-details',
  ASSIGN_LICENSE: 'assign-license',
}

const propTypes = {
  selectedEmployee: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  values: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  licenses: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
  onEditTab: PropTypes.func.isRequired,
}

function AddUserReviewTab({ selectedEmployee = null, values, licenses = [], onEditTab }) {
  const domainValue = getGwsDomainValue(values?.domain)
  const accountEmail = selectedEmployee?.email || `${values?.username}@${domainValue}`
  const selectedLicenses = licenses.filter((license) => values?.licenses?.includes(license.id))

  return (
    <>
      <p className="font-bolder font-lg mb-2">
        <FormattedMessage id="ENGAGE.ACCOUNT_DETAILS_C" />
      </p>
      <p className="m0">{accountEmail}</p>
      <Button variant="link" className="mb-4 ps-0 pe-0" onClick={() => onEditTab(TAB_KEYS.ACCOUNT_DETAILS)}>
        <FormattedMessage id="GENERAL.EDIT" />
      </Button>

      {values?.isResettingPassword && (
        <>
          <p className="font-bolder font-lg mb-2">
            <FormattedMessage id="ENGAGE.PASSWORD_SETTINGS" />
          </p>
          {values.isAutoGeneratingPassword && (
            <p className="m0">
              <FormattedMessage id="ENGAGE.AUTO_GENERATE" />
            </p>
          )}
          {values.changePasswordAtNextLogin && (
            <p className="m0">
              <FormattedMessage id="ENGAGE.REQUIRE_USER_TO_CHANGE_PASSWORD" />
            </p>
          )}
          <Button variant="link" className="mb-4 ps-0 pe-0" onClick={() => onEditTab(TAB_KEYS.ACCOUNT_DETAILS)}>
            <FormattedMessage id="GENERAL.EDIT" />
          </Button>
        </>
      )}

      <p className="font-bolder font-lg mb-2">
        <FormattedMessage id="ENGAGE.LICENSES_TO_BE_ASSIGNED" />
      </p>
      {selectedLicenses.map((license) => (
        <p key={license.id} className="mb-0">
          {license.displayName}
        </p>
      ))}
      <Button variant="link" className="mb-4 ps-0 pe-0" onClick={() => onEditTab(TAB_KEYS.ASSIGN_LICENSE)}>
        <FormattedMessage id="GENERAL.EDIT" />
      </Button>
    </>
  )
}

AddUserReviewTab.propTypes = propTypes

export default AddUserReviewTab
